/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Person status
 * @export
 * @interface InternalApiPersonStatus
 */
export interface InternalApiPersonStatus {
    /**
     * 
     * @type {InternalApiPersonStatusStatusEnum}
     * @memberof InternalApiPersonStatus
     */
    status: InternalApiPersonStatusStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiPersonStatusStatusEnum {
    NEW = 'NEW',
    REVIEWED = 'REVIEWED',
    MONITORING = 'MONITORING',
    SUSPENDED = 'SUSPENDED',
    TERMINATED = 'TERMINATED',
    TERMINATED_AND_REPORTED = 'TERMINATED_AND_REPORTED'
}


/**
 * Check if a given object implements the InternalApiPersonStatus interface.
 */
export function instanceOfInternalApiPersonStatus(value: object): value is InternalApiPersonStatus {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function InternalApiPersonStatusFromJSON(json: any): InternalApiPersonStatus {
    return InternalApiPersonStatusFromJSONTyped(json, false);
}

export function InternalApiPersonStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function InternalApiPersonStatusToJSON(json: any): InternalApiPersonStatus {
    return InternalApiPersonStatusToJSONTyped(json, false);
}

export function InternalApiPersonStatusToJSONTyped(value?: InternalApiPersonStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

